import {
  GeckoComponentPath,
  isWrapType,
  WrapType,
} from 'types/geometric/geckoComponentPath'
import { GeckoComponentSpace } from 'types/geometric/geckoComponentSpace'

import { GeckoMarkupPrimitive } from './geckoMarkupPrimitive'

/**
 * Markup lines are path-based lines on a component, connecting any number of
 * points. Note that points are in 2D component coordinates.
 * TODO ENT-1166: Describe how line wrapping works
 */
export class GeckoMarkupLine extends GeckoMarkupPrimitive {
  //----------------------------------------------------------------------------

  public readonly kind = 'line'
  public readonly path: GeckoComponentPath

  private constructor(
    id: string,
    markupLayerID: string,
    json: Record<string, unknown>,
    markupBounds: GeckoComponentSpace
  ) {
    if (!Array.isArray(json.points) || json.points.length === 0)
      throw new Error(`Primitive "${id}" malformed: ${JSON.stringify(json)}`)
    const points = json.points as { x: number | string; y: number | string }[]

    const rawWraps: ReadonlyArray<ReadonlyArray<WrapType>> | undefined =
      json.wraps as ReadonlyArray<ReadonlyArray<WrapType>> | undefined

    console.assert(
      !rawWraps ||
        rawWraps
          .map((wrapsElm) => {
            return (
              Array.isArray(wrapsElm) && !wrapsElm.find((e) => !isWrapType(e))
            )
          })
          .reduce((boolOne, boolTwo) => boolOne && boolTwo),
      `Wraps array is malformed: ${rawWraps}`
    )
    const wraps: ReadonlyArray<ReadonlySet<WrapType>> | undefined =
      rawWraps?.map((wrapsElm) => new Set(wrapsElm.filter(isWrapType)))

    if (wraps && wraps.length !== points.length - 1) {
      throw new Error(
        `Primitive "${id}" malformed: ${JSON.stringify(json)} (Bad wraps count)`
      )
    }

    try {
      const path = GeckoComponentPath.CreateFromPointsAndWraps(
        markupBounds.componentID,
        points,
        markupBounds.x.unit,
        markupBounds.y.unit,
        wraps
      )
      super(id, markupLayerID, path.bounds)
      this.path = path
    } catch {
      throw new Error(`Primitive "${id}" malformed: ${JSON.stringify(json)}`)
    }
  }

  //----------------------------------------------------------------------------

  public static CreateFromJSON(
    id: string,
    markupLayerID: string,
    json: Record<string, unknown>,
    markupBounds: GeckoComponentSpace
  ) {
    return new GeckoMarkupLine(id, markupLayerID, json, markupBounds)
  }
}
